<template>
  <div class="footer bg-secondary text-light text-center">
    Designed & Built by Paul Duvall - <a href="http://www.pjduvall.com" target="_blank">pjduvall.com</a>
    / <i><a href="https://github.com/paul-duvall/boardgame-picker" target="_blank">Project code</a></i>
  </div>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>


<style>
.footer {
  padding: .5rem 0;
}

.footer a {
  color: white;
}
</style>